module.exports = __webpack_public_path__ + "img/qr5.8ab904cd.png";